export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5056.25e48860.jpg";